<lms-toolbar>
  <div class="lms-toolbar__block">
    <div class="lms-toolbar__item">
      <lms-search-field [listId]="distributorCreditsPurchasesListId"></lms-search-field>
      <lms-items-count-selector class="hide-on-med-and-down" [listId]="distributorCreditsPurchasesListId">
      </lms-items-count-selector>
    </div>
    <div class="lms-toolbar__item">
      <lms-broker-credits-dealer
        [transactionType]="
          distributor.subscriptions.credits ? dealerService.CREDITS_SALE : dealerService.SUBSCRIPTIONS_SALE
        "
        [distributor]="distributor"
        (transactionCompleted)="onTransactionCompleted()"
      ></lms-broker-credits-dealer>
    </div>
  </div>
</lms-toolbar>
<ul class="list__heading">
  <li>
    {{ (distributor.subscriptions.credits ? 'distributors.creditsBalance' : 'distributors.balanceSeats') | translate }}:
    <b>{{ distributor.brokerBalance.amount }}</b>
  </li>
  <li *ngIf="distributor.type === 'distributor'">
    {{ 'nouns.expirationDate' | translate }}: <b>{{ distributor.brokerBalance.expirationDate | date }}</b>
  </li>
</ul>
<h5 class="heading-6">
  {{ (distributor.subscriptions.credits ? 'distributors.creditsPurchases' : 'distributors.buySeats') | translate }}
</h5>
<lms-broker-credits-purchases [hideCredits]="true" [distributor]="distributor"></lms-broker-credits-purchases>
<lms-toolbar>
  <div class="lms-toolbar__block">
    <div class="lms-toolbar__item">
      <lms-search-field [listId]="distributorCreditsSaleslistId"></lms-search-field>
      <lms-items-count-selector class="hide-on-med-and-down" [listId]="distributorCreditsSaleslistId">
      </lms-items-count-selector>
    </div>
  </div>
</lms-toolbar>
<h5 class="heading-5">
  {{ (distributor.subscriptions.credits ? 'distributors.creditsSales' : 'distributors.seats') | translate }}
</h5>
<lms-broker-credits-sales [hideCredits]="true" [distributor]="distributor"></lms-broker-credits-sales>
